enum GatheringPrivacy {
  DisableGenAi = 'DisableGenAI',
  EnableComments = 'EnableComments',
  EnforcedContentPolicy = 'EnforcedContentPolicy',
  FullPublic = 'FullPublic',
  HideDuplicatePhotos = 'HideDuplicatePhotos',
  PasswordRequired = 'PasswordRequired',
  PublicPreview = 'PublicPreview',
  /** @deprecated Use UploadApproval instead */
  RestrictUpload = 'RestrictUpload',
  /** @deprecated No longer supported */
  RestrictViewToFilter = 'RestrictViewToFilter',
  UploadApproval = 'UploadApproval'
}
export default GatheringPrivacy
